import { CommonModule } from '@angular/common';
import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PageErrorMessageModule } from 'Angular/features/components/page-error-message/page-error-message.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { CapitalGainsFeatureCheckComponent } from './components/capital-gains-feature-check/capital-gains-feature-check.component';
import { FundHistoricDistributionsComponent } from './components/fund-historic-distributions/fund-historic-distributions.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { PageErrorMessageComponent } from 'Angular/features/components/page-error-message/page-error-message.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { SingleSeriesFundChartComponent } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.component';
import { DataTabAutocompleteComponent } from 'SecuritiesApp/ts/features/data-tab-autocomplete/data-tab-autocomplete.component';
import { HistoricalDataTableComponent } from 'SecuritiesApp/ts/features/historical-data-table/historical-data-table.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import * as i0 from "@angular/core";
const entryComponents = [
    SideMenuComponent,
    TopBarNavComponent,
    HistoricalDataTableComponent,
    SecurityHeaderControlComponent,
    SingleSeriesFundChartComponent,
    DataTabAutocompleteComponent,
    CapitalGainsFeatureCheckComponent,
    FundHistoricDistributionsComponent,
    PageErrorMessageComponent,
];
export class IncomeDataAppModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [HistoricalDataTableComponent, SingleSeriesFundChartComponent];
    }
}
IncomeDataAppModule.ɵfac = function IncomeDataAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IncomeDataAppModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
IncomeDataAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IncomeDataAppModule });
IncomeDataAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule,
        CommonModule,
        IconModule,
        BaseSecurityPageModule,
        PageErrorMessageModule,
        CapitalGainsFeatureCheckComponent,
        FundHistoricDistributionsComponent] });
